export default __webpack_public_path__ + "static/1616-f5fbc1a2e029f66699d72fcc0284651c.gif";